import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import './index.css';
import { App } from './app/App';
import { initializeAuth } from './features/auth/api/auth.api';
import { initSentry } from '@/shared/lib/sentry';
import { authService } from '@/features/auth/services/auth.service';

initSentry();

authService.user$.subscribe(user => {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email });
  } else {
    Sentry.setUser(null);
  }
});

initializeAuth().subscribe(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Sentry.ErrorBoundary
        fallback={<p className="text-rose-400 p-4">Prišlo je do napake / An error occurred.</p>}
      >
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );
});
